module.exports = __webpack_public_path__ + "img/hnsxdfw.a5333e95.png";